import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.elementsExchange'),
    id: 'shipments',
    sidebar: [
        {
            id: 'automaticShipmentRules',
            label: i18n.t('configuration.sections.automaticShipmentRules'),
            icon: 'far fa-magic',
            routeName: 'AutomaticShipmentRules',
            hasChildren: false
        },
        // TODO Front: next icon must be use in Manual Shipment Rules Grid
        {
            id: 'manualShipmentRules',
            label: i18n.t('configuration.sections.manualShipmentRules'),
            icon: 'far fa-box',
            routeName: 'ManualShipmentRules',
            hasChildren: false
        }
    ]
}
